import ModalSurface from '../shared/ModalSurface';
import { useState, useEffect, useMemo, useCallback } from 'react';

function AddChartAccountModal({ onClose, onSave }) {
    const [formData, setFormData] = useState({
        name: '',
        type: 'expense',
        description: ''
    });
     const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };
     return (
        <ModalSurface panelProps={{ 'data-m7-touch': true }} onClose={onClose} label="Add Account Category" panelClassName="bg-white rounded-lg shadow-xl max-w-lg w-full">
                <div className="ia-modal-layout p-6">
                    <h3 className="text-2xl font-bold mb-4">Add Account Category</h3>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="ia-modal-body space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Category Name *</label>
                            <input type="text" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[var(--accent-ink)]" 
                                placeholder="e.g., Fuel, Vehicle Repairs, Service Revenue" required />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Type *</label>
                            <select value={formData.type} onChange={(e) => setFormData({...formData, type: e.target.value})}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[var(--accent-ink)]" required>
                                <option value="income">Income</option>
                                <option value="expense">Expense</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Description (Optional)</label>
                            <textarea value={formData.description} onChange={(e) => setFormData({...formData, description: e.target.value})}
                                rows="3" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[var(--accent-ink)]" 
                                placeholder="Brief description of this account category" />
                        </div>
                        </div>
                        <div className="ia-modal-actions flex justify-end gap-3 mt-6">
                            <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">
                                Cancel
                            </button>
                            <button type="submit" className="px-4 py-2 bg-[var(--btn-fill)] text-[var(--btn-ink)] rounded-lg hover:bg-[var(--btn-fill-hover)]">
                                Add Category
                            </button>
                        </div>
                    </form>
                </div>
        </ModalSurface>
    );
}


export default AddChartAccountModal;
